const values = [
  { label: "LABORAL", value: 1 },
  { label: "CIVIL Y COMERCIAL", value: 2 },
  { label: "ADMINISTRATIVO", value: 3 },
  { label: "OTRO", value: 4 },
];

export default values;
